import GetAppRoundedIcon from "@mui/icons-material/GetAppRounded";
import { Card, CircularProgress } from "@mui/material";
import DOMPurify from "dompurify";
import { Parser as HtmlToReactParser } from "html-to-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEmailContent } from "../../../../actions/emails";
import { StyledDetailsTable } from "../../../styled/email";
import { StyledFlex } from "../../../styled/flex";

const htmlToReactParser = new HtmlToReactParser();

const DetailsTableEmails = ({ rowData }) => {
  const dispatch = useDispatch();
  const emails = useSelector((state) => state.emails);
  const email = emails.list.find(
    (e) => e.idEmailEnviado === rowData.idEmailEnviado,
  );
  const content = email ? email.content : null;

  useEffect(() => {
    if (!emails.isFetchingContent && !content) {
      dispatch(
        getEmailContent(rowData.mlPointCoreArtId, rowData.idEmailEnviado),
      );
    }
  }, []);

  if (!content) {
    return (
      <StyledDetailsTable.Container>
        <Card>
          <StyledDetailsTable.LoadingContainer>
            <CircularProgress />
          </StyledDetailsTable.LoadingContainer>
        </Card>
      </StyledDetailsTable.Container>
    );
  } else {
    const images = content.adjuntos.map((f) =>
      f.extension.toLowerCase() !== "pdf" ? (
        <StyledDetailsTable.Image
          alt={f.nombre}
          src={`data:image/${f.extension};base64,${f.adjunto}`}
          key={f.nombre}
        />
      ) : null,
    );

    const pdfs = content.adjuntos.map((f) =>
      f.extension.toLowerCase() === "pdf" ? (
        <StyledDetailsTable.PdfButton
          component="button"
          variant="body2"
          key={f.nombre}
          onClick={() => {
            const downloadLink = document.createElement("a");
            downloadLink.href = `data:application/pdf;base64,${f.adjunto}`;
            downloadLink.download = f.nombre;
            downloadLink.click();
          }}>
          <div>
            <div>{f.nombre.replace("-", "_").replace(/\s+/g, "")}</div>
            <GetAppRoundedIcon />
          </div>
        </StyledDetailsTable.PdfButton>
      ) : null,
    );

    return (
      <StyledDetailsTable.Container>
        <Card>
          <StyledFlex.ColumnContainer>
            <div>
              <StyledDetailsTable.TextTitle>
                Cuerpo:
              </StyledDetailsTable.TextTitle>
              <StyledDetailsTable.TextValue>
                {content.cuerpo &&
                  htmlToReactParser.parse(
                    DOMPurify.sanitize(content.cuerpo.replace(/>\s+</g, "><")),
                  )}
              </StyledDetailsTable.TextValue>
            </div>
            {pdfs.length !== 0 || images.length !== 0 ? (
              <div>
                <StyledDetailsTable.TextTitle>
                  Adjuntos:
                </StyledDetailsTable.TextTitle>
                <div>
                  <div>{pdfs}</div>
                  <div>{images}</div>
                </div>
              </div>
            ) : null}
          </StyledFlex.ColumnContainer>
        </Card>
      </StyledDetailsTable.Container>
    );
  }
};

export default DetailsTableEmails;
